import React from 'react';
import StringSounds from '../components/StringSounds';
import Tuner from '../components/Tuner';

const TunerPage = () => {
  return (
    <div style={styles.container}>
      <StringSounds />
      <Tuner />
    </div>
  );
};

export default TunerPage;

// Styles for the page
const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  },
};
